module.exports = __webpack_public_path__ + "static/NHaasGroteskTXStd-56It-700e20bae650f9b16e6c8965f5de111a.woff2";